var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { color } from "metabase/lib/colors";
import Icon from "metabase/components/Icon";
import Link from "metabase/core/components/Link";
import { shouldForwardNonTransientProp } from "metabase/lib/styling/emotion";
const propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  activeColor: PropTypes.string,
  inactiveColor: PropTypes.string
};
function RawMaybeLink(_a) {
  var _b = _a, { to, activeColor, inactiveColor } = _b, props = __objRest(_b, ["to", "activeColor", "inactiveColor"]);
  return to ? /* @__PURE__ */ _jsx(Link, __spreadValues({
    to
  }, props)) : /* @__PURE__ */ _jsx("span", __spreadValues({}, props));
}
RawMaybeLink.propTypes = propTypes;
const hoverStyle = (props) => css`
  cursor: pointer;
  color: ${color(props.activeColor)};
`;
export const MaybeLink = styled(RawMaybeLink)`
  display: flex;
  align-items: center;
  font-size: 0.875em;
  font-weight: bold;
  color: ${(props) => color(props.inactiveColor)};
  min-width: ${(props) => props.isSingleLine ? 0 : ""};

  :hover {
    ${(props) => (props.to || props.onClick) && hoverStyle(props)}
  }
`;
export const BadgeIcon = styled(Icon, {
  shouldForwardProp: shouldForwardNonTransientProp
})`
  margin-right: ${(props) => props.$hasMargin ? "5px" : 0};
`;
export const BadgeText = styled.span`
  overflow: ${(props) => props.isSingleLine ? "hidden" : ""};
  text-overflow: ${(props) => props.isSingleLine ? "ellipsis" : ""};
  white-space: ${(props) => props.isSingleLine ? "nowrap" : ""};
`;
